import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "methodLabel", "backupLabel", "expiryHint", "resendRow",
    "backupToggle", "sendCodeLink", "methodToggle",
    "codeInput", "fieldError", "fieldErrorIcon", "modeField",
  ]

  static values = { cleanFieldClass: String }

  useBackupCode(event) {
    event?.preventDefault()
    this.switchTo("backup")
  }

  useMethodCode(event) {
    event?.preventDefault()
    this.switchTo("method")
  }

  switchTo(mode) {
    const backup = mode === "backup"

    this.setHidden(backup, this.methodLabelTargets, this.expiryHintTargets, this.resendRowTargets, this.backupToggleTargets)
    this.setHidden(!backup, this.backupLabelTargets, this.sendCodeLinkTargets, this.methodToggleTargets)
    this.modeFieldTargets.forEach((field) => { field.value = backup ? "1" : "0" })
    this.clearError()

    const input = this.codeInputTargets[0]
    if (input) {
      input.value = ""
      input.focus()
    }
  }

  clearError() {
    this.fieldErrorTargets.forEach((element) => element.replaceChildren())
    this.fieldErrorIconTargets.forEach((element) => element.replaceChildren())

    const input = this.codeInputTargets[0]
    if (!input) return

    if (this.hasCleanFieldClassValue) input.className = this.cleanFieldClassValue
    input.removeAttribute("aria-invalid")
    input.removeAttribute("aria-describedby")
  }

  setHidden(hidden, ...groups) {
    groups.flat().forEach((element) => element.classList.toggle("hidden", hidden))
  }
}
